import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import logo from '../../../assets/logo_white.png';
import styles from './NewUserForm.styles';
import { UserValidations } from '../../../models';

import Image from '../../common/image/Image';
import LoginButton from '../../inputs/loginbutton/LoginButton';
import LoginInput from '../../inputs/logininput/LoginInput';
import FormField from '../formfield/FormField';
import PasswordInput from '../../inputs/password/PasswordInput';
import FormError from '../formerror/FormError';

export class NewUserForm extends Component {
  render() {
    const { error } = this.props;
    return (
      <form className={css(styles.form)} onSubmit={this.props.handleSubmit}>
        <Image src={logo} alt="logo" styles={styles.logo} />
        <p className={css(styles.p)}>{I18n.t('newuser.txt')}
        <br />{I18n.t('resetPassword.passwordRules')}</p>
        {error && (
          <FormError title={I18n.t('login.errorTitle')}>
            {I18n.t('login.errorBody')}
          </FormError>
        )}
        <Field
          name="email"
          type="value"
          readOnly={true}
          placeholder={I18n.t('login.email')}
          input={{value: this.props.email || ''}}
          component={LoginInput}
        />
        <Field
          name="password"
          minLength="8"
          maxLength="20"
          required
          validate={UserValidations.password}
          component={PasswordInput}
          />
        <Field
          name="token"
          type="hidden"
          input={{value: this.props.token || ''}}
          component={FormField}
        />
        <div
          className={css(
            styles.actions,
            this.props.createError && styles.actionsError
          )}
        >
          <LoginButton>{I18n.t('resetPassword.save')}</LoginButton>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'newuser'
})(NewUserForm);



// WEBPACK FOOTER //
// ./src/components/forms/newuser/NewUserForm.js